// Angular imports
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// 3rd party imports
import { map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { classToPlain, plainToClass } from 'class-transformer';

// Constant imports
import { URLConstants } from '../../_constants/url-constants';

// Model imports
import { TimeExpenseSubmissionHistoryResultDto } from '../_models/time-expense-submission-history-result-dto';
import { TimeExpenseSubmissionActionBaseParametersDto } from '../_models/time-expense-submission-action-base-parameters-dto';
import { TimeExpenseEmailSubmissionSaveNoteParameterDto } from '../_models/time-expense-email-submission-save-note-parameter-dto';

@Injectable({
    providedIn: 'root'
})
export class TimeExpenseComfirmationService {
    private readonly _subjectLoading = new Subject<boolean>();

    constructor(private readonly httpClient: HttpClient) {}

    onLoadingEvent(): Subject<boolean> {
        return this._subjectLoading;
    }
    showLoading(): void {
        this._subjectLoading.next(true);
    }
    hideLoading(): void {
        this._subjectLoading.next(false);
    }

    getTimeAndExpenseSubmissionDetail(
        baseParams: TimeExpenseSubmissionActionBaseParametersDto
    ): Observable<TimeExpenseSubmissionHistoryResultDto> {
        const url = `${URLConstants.ccTimeAndExpenseEmailConfirmationUrl}/detail${baseParams.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((plain: any) => plainToClass(TimeExpenseSubmissionHistoryResultDto, plain)));
    }

    getTimeAndExpenseReport(baseParams: TimeExpenseSubmissionActionBaseParametersDto): Observable<Blob> {
        const url = `${URLConstants.ccTimeAndExpenseEmailConfirmationUrl}/report${baseParams.getQueryString()}`;
        return this.httpClient
            .get(url, { responseType: 'arraybuffer' })
            .pipe(map((response: any) => new Blob([response])));
    }

    updateTimeNotes(params: TimeExpenseEmailSubmissionSaveNoteParameterDto): Observable<any> {
        const url = `${URLConstants.ccTimeAndExpenseEmailConfirmationUrl}/item/time/note`;
        return this.httpClient.put(url, classToPlain(params));
    }

    updateExpenseNotes(params: TimeExpenseEmailSubmissionSaveNoteParameterDto): Observable<any> {
        const url = `${URLConstants.ccTimeAndExpenseEmailConfirmationUrl}/item/expense/note`;
        return this.httpClient.put(url, classToPlain(params));
    }

    updateMileageNotes(params: TimeExpenseEmailSubmissionSaveNoteParameterDto): Observable<any> {
        const url = `${URLConstants.ccTimeAndExpenseEmailConfirmationUrl}/item/mileage/note`;
        return this.httpClient.put(url, classToPlain(params));
    }

    approveTimeExpenseSubmission(params: TimeExpenseSubmissionActionBaseParametersDto): Observable<any> {
        const url = `${URLConstants.ccTimeAndExpenseEmailConfirmationUrl}/approve`;
        return this.httpClient.put(url, classToPlain(params));
    }

    denyTimeExpenseSubmission(params: TimeExpenseSubmissionActionBaseParametersDto): Observable<any> {
        const url = `${URLConstants.ccTimeAndExpenseEmailConfirmationUrl}/deny`;
        return this.httpClient.put(url, classToPlain(params));
    }
}
